import(/* webpackMode: "eager", webpackExports: ["AboutUsView"] */ "D:\\FekerTech\\Shahen Website New\\src\\sections\\about\\view\\about-view.jsx");
